import { render, staticRenderFns } from "./GoPOSDashboard.vue?vue&type=template&id=8f25bf48"
import script from "./GoPOSDashboard.vue?vue&type=script&lang=js"
export * from "./GoPOSDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports